export enum HttpStatusCodeEnum {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBBIDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  PRECONDITION_FAILED = 412,
  LIMIT_NUMBER_EXPIRATION = 417,
  INTERNAL_SERVER_ERROR = 500,
}
